import React from 'react';
import '../../styles/corpoClinico.css';
import PsicoTccThais from '../../img/corpoClinico/psicoTccThais.jpg'
import PsicoTccLuciane from '../../img/corpoClinico/PsicoTccLuciane.jpg'
import PsicoClinicaTcc from '../../img/corpoClinico/PsicologaClinica.jpg';
import PsicoTccCassio from '../../img/corpoClinico/PsicoCassio.jpg'
import PsicoTccLisiane from '../../img/corpoClinico/psicoTccLisiane.jpg'
import PsicoTccMateus from '../../img/corpoClinico/PsicoTccMateus.jpg'
import PsicoTccRoger from "../../img/corpoClinico/psicoTccRoger.jpg"
import SemFoto from '../../img/corpoClinico/sem_foto.jpg';

const CorpoClinico: React.FC = () => {
  return (
    <>
      <div className='title_clinic'>
        <h2 className="titulo" id="Corpo_Clinico_Psico_Sistemica">Corpo Clínico</h2>
      </div>

      <div className="space"><br /></div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={PsicoTccCassio} alt="Cássio" />
            </div>
            <div className="space"></div>
            <div className="info-container">
              <h3 className="nome">Cássio Saldanha</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Esta área foi reservada para que o(a) profissional possa compartilhar
                suas formações acadêmicas, especializações, abordagens terapêuticas
                e experiências clínicas relevantes.
                Os dados de registro profissional no conselho da categoria são
                verificados e mantidos atualizados pela clínica."
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space"><br /></div>
      
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={PsicoClinicaTcc} alt="Gilca" />
            </div>
            <div className="space"></div>
            <div className="info-container">
              <h3 className="nome">Daniela Santos de Souza</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Psicóloga TCC, Psicóloga que atua em psicoterapia cognitivo comportamental de jovens e adultos. Possui
                formação em Psicologia (Uniritter), especialização em Terapia Cognitivo Comportamental
                (CBI Of Miami), cursando especialização em Orientação Profissional e Carreira (Faveni),
                entre demais certificações em cursos livres. Possui formação na área de Gestão de
                Recursos Humanos (Uniritter) e MBA em Gestão Empresarial (Uniritter). Registro
                profissional e-PSI e registro em Conselho Regional de Psicologia CRPRS 07/38821."
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space"><br /></div>
      
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={PsicoTccLisiane} alt="Lisiane" />
            </div>
            <div className="space"></div>
            <div className="info-container">
              <h3 className="nome">Lisiane Chang</h3>
             {/*} <a href=""
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Psicóloga formada pela Universidade Paulista, com especialização em Psicologia Organizacional e pós-graduação em Gestão de Pessoas. 
                Atua com orientação profissional e atendimento clínico de adultos, utilizando a Terapia Cognitiva Comportamental (TCC) como base."
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space"><br /></div>

      <div className="space"><br /></div>
      
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={PsicoTccMateus} alt="Mateus" />
            </div>
            <div className="space"></div>
            <div className="info-container">
              <h3 className="nome">Mateus Silva de Oliveira</h3>
             {/*} <a href=""
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Formado pela UniRitter, atua com as abordagens cognitiva e transpessoal. Meu trabalho é focado no tratamento de transtornos como depressão,
                ansiedade, fobias, luto e questões relacionadas à busca de sentido."
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space"><br /></div>

      <div className="space"><br /></div>
      
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={PsicoTccRoger} alt="Gilca" />
            </div>
            <div className="space"></div>
            <div className="info-container">
              <h3 className="nome">Roger Ferraz</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Roger Ferraz é psicólogo formado pela Unilasalle, com atuação em psicoterapia cognitivo-comportamental. 
                 Atende adultos e idosos, auxiliando no manejo de questões emocionais, comportamentais e na promoção da saúde mental."
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space"><br /></div>

      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={PsicoTccThais} alt="Gilca" />
            </div>
            <div className="info-container">
              <h3 className="nome">Thaís Kleine França</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Psicóloga que atua em psicoterapia cognitivo comportamental para adultos. 
                 Formação em Psicologia (Uniritter), pós-graduanda em Terapia Cognitivo Comportamental
                (Fernanda Landeiro) e cursando especialização em Psicopatologia (Fernanda Landeiro). 
                Experiência em clínicas de internação psiquiátrica, residencial psiquiátrico, na área jurídica realizando perícias na vara de família, 
                formulação de laudos e atendimento infantil. Registro no Conselho Regional de Psicologia CRPRS 07/42812."
              </p>
            </div>
          </div>
        </div>
      </div>


      <div className="botao-container">
        <br></br>
      </div>
    </>
  );
};

export default CorpoClinico;